import { useSelector } from "react-redux";
import { useMemo } from "react";

/**
 * Hook de acesso ao sistema novo de permissoes (Fase 2/3).
 *
 * Le ``userDetails.permissions`` (lista de atomos como "results.view")
 * vinda do endpoint post_login_info. Durante a coexistencia, o gating
 * legado por ``userDetails.user_role`` continua valendo nos lugares que
 * ainda nao migraram — este hook e' a forma nova e granular.
 *
 * Uso:
 *   const { can, canAny, canAll, permissions } = usePermissions();
 *   if (can("results.view")) { ... }
 *   if (canAny(["governance.initiatives.create", "governance.initiatives.edit"])) { ... }
 */
export default function usePermissions() {
  const userDetails = useSelector((state) => state.auth.userDetails);

  const permissionSet = useMemo(() => {
    const list = userDetails?.permissions || [];
    return new Set(list);
  }, [userDetails?.permissions]);

  const can = (code) => permissionSet.has(code);

  const canAny = (codes = []) => codes.some((c) => permissionSet.has(c));

  const canAll = (codes = []) => codes.every((c) => permissionSet.has(c));

  return {
    permissions: permissionSet,
    can,
    canAny,
    canAll,
  };
}
